function show_add_file_form(el, classname) {
  $("." + classname + ":hidden")
    .first()
    .prop("disabled", false)
    .show();
}
function show_confirm(el, show_confirm) {
  var modal = $(el).closest(".modal-dialog");
  modal.find(".state-confirm").toggle(show_confirm);
  modal.find(".state-editable").toggle(!show_confirm);
  modal
    .find("input[type=text],textarea,select,.article-radio")
    .each(function () {
      var input_id = $(this).attr("id");
      var confirm_id = input_id + "-confirm";
      var confirm_el = $("#" + confirm_id);
      if (confirm_el.length == 0) {
        confirm_el = $("<span />").attr("id", confirm_id);
        $(this).after(confirm_el);
      }
      var confirm_text = "";
      if ($(this).is("select")) {
        confirm_text = $(this).children(":selected").text();
      } else if ($(this).is(".article-radio")) {
        confirm_text = $(this)
          .find("input[type=radio]:checked")
          .closest(".form-check")
          .find("label")
          .text()
          .replace(/\r?\n/g, "");
      } else {
        confirm_text = $(this).val();
      }
      confirm_el.html(
        $("<div />").text(confirm_text).html().replace(/\r?\n/g, "<br />")
      );
      confirm_el.toggle(show_confirm);
      $(this).toggle(!show_confirm);
    });
  modal.toggleClass("confirm", show_confirm);
}
function toggle_attendance_option(el) {
  $(".use-attendance-option").toggle();
  //el.hide();
}
function toggle_event_article_event(el) {
  $(".event-article-event").toggle();
  //el.hide();
}

// Export functions to make them globally available
window.show_add_file_form = show_add_file_form;
window.show_confirm = show_confirm;
window.toggle_attendance_option = toggle_attendance_option;
window.toggle_event_article_event = toggle_event_article_event;
